import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';

function useTerms(termCategoryId: string) {
  const { data } = useQuery(queries.terms.list(termCategoryId));
  const terms = data?.terms;
  const [termId, setTermId] = useState<string|undefined>();
  const { data: mainData } = useQuery(queries.terms.main(termCategoryId));
  const currentTerm = useMemo(
    () => terms?.find((term) => term.id === termId),
    [termId, terms],
  );
  useEffect(() => {
    if (mainData) {
      setTermId(mainData.id);
    }
  }, [mainData]);
  return {
    terms, currentTerm, termId, setTermId,
  };
}

export default useTerms;
